import { render, staticRenderFns } from "./EditNumbersModal.vue?vue&type=template&id=bfa9573a&"
import script from "./EditNumbersModal.vue?vue&type=script&lang=js&"
export * from "./EditNumbersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports